<template>
  <div id="app">
    <Header></Header>
    <Back></Back>
    <transition
        name="fade"
        mode="out-in"
      >
      <router-view/>
    </transition>
  </div>
</template>

<script>

import Header from '@/components/TheHeader'
import Back from '@/components/TheBackButton'

export default {
  components: {
    Header,
    Back
  }
}
</script>

<style lang="scss">
  @import "../src/assets/scss/global.scss";
</style>
